import { type FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Card } from '@dhl-ui/components'
import {
  type Servicepoint,
  ServicepointList,
  ServicepointListSkeleton,
  useServicepointSearch,
} from '@dhl/receiver-servicepoint'
import { SearchBox, StickySearchBoxContainer } from '@dhl/search'

type ServicepointSelectProps = {
  isLoading: boolean
  servicepoints: Servicepoint[]
  onServicepointClick: (servicepoint: Servicepoint) => void
}

export const ServicepointSelect: FC<ServicepointSelectProps> = ({ isLoading, servicepoints, onServicepointClick }) => {
  const { t } = useTranslation()
  const {
    onSearchTermChange,
    onSearchTermClear,
    searchTerm,
    results: servicepointsToShow,
  } = useServicepointSearch(servicepoints ?? [])

  return (
    <Card hasPaddingBottom hasPaddingTop>
      <Card.Header title={t('portal.profile.preferences.setupPage.servicePoint.listCardTitle')} />
      <Card.Content noPaddingSides>
        <StickySearchBoxContainer>
          <SearchBox
            searchTerm={searchTerm}
            sx={{ mb: 2 }}
            onSearchTermChange={onSearchTermChange}
            onSearchTermClear={onSearchTermClear}
          />
        </StickySearchBoxContainer>

        {isLoading && <ServicepointListSkeleton data-testid="servicepoint-list-skeleton" numberOfItems={5} />}

        {!isLoading && (
          <ServicepointList
            data-testid="servicepoint-list"
            servicepoints={servicepointsToShow}
            showOpeningTimes={false}
            onClick={onServicepointClick}
          />
        )}
      </Card.Content>
    </Card>
  )
}
